'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** ../~/dom-helpers/util/inDOM.js
 ** module id = 233
 ** module chunks = 0
 **/